<template>
  <div class="box">
    <div>
      <!-- Using modifiers -->

      <b-button pill variant="success" v-b-modal.my-modal font-scale="1" class="mb-2">
        <b-icon icon="plus-circle"></b-icon>
      </b-button>
    </div>
    <div>
      <!-- Using value -->
      <b-button v-b-modal="'my-modal'">Show Modal</b-button>
    </div>

    <!-- The modal -->
    <b-modal id="my-modal">
      <CategoryForm :task="this.category" :values="this.category.subcategories" :update="true" />
    </b-modal>
  </div>
</template>
<script>
import CategoryForm from "./../components/tasks/TaskForm.vue";
export default {
  components: {
    CategoryForm
  },
  data() {
    return {
      category: {
        type: Object,
        default: {
          category_id: 1,
          name: "Caballos",
          is_menu: true,
          subcategories: [
            {
              subcategory_id: 1,
              name: "subcategory caballos 1"
            },
            {
              subcategory_id: 2,
              name: "subcategory caballos 2"
            },
            {
              subcategory_id: 3,
              name: "subcategory caballos 3"
            }
          ]
        }
      }
    };
  }
};
</script>
<style>
</style>